module.exports = __webpack_public_path__ + "static/img/third2.583c4ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/third2.png
// module id = 4nk0
// module chunks = 25